import { theme as baseTheme } from 'localmed-core';

// Add app-specific properties to the theme here

const theme = {
  ...baseTheme,
};

export default theme;
